import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTabsModule } from '@angular/material/tabs';
import { AdminDashRoutingModule } from './admin-dash-routing.module';
import { SharedModule } from 'src/app/shared/shared.module';

import { AdminLayoutComponent } from './admin-layout/admin-layout.component';
import { AdminLoginComponent } from './login/login.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { UtilitiesListComponent } from './utilities/utilities-list/utilities-list.component';
import { UtilitiesAddComponent, StatusDialogComponent } from './utilities/utilities-add/utilities-add.component';
import { UtilitiesEditComponent } from './utilities/utilities-edit/utilities-edit.component';
import { ConfigurationPanelComponent } from './configuration/configuration-panel/configuration-panel.component';
import { UserPermissionsComponent } from './configuration/user-permissions/user-permissions.component';
import { BiddingTypeComponent } from './configuration/bidding-type/bidding-type.component';
import { UtilityConfigComponent } from './configuration/utility-config/utility-config.component';
import { BidRoundManagementComponent } from './bid-round-management/bid-round-management.component';
import { AdminComponent } from './test/admin/admin.component';

@NgModule({
  declarations: [
    AdminLayoutComponent,
    AdminLoginComponent,
    DashboardComponent,
    UtilitiesListComponent,
    UtilitiesAddComponent,
    UtilitiesEditComponent,
    ConfigurationPanelComponent,
    UserPermissionsComponent,
    BiddingTypeComponent,
    UtilityConfigComponent,
    BidRoundManagementComponent,
    StatusDialogComponent,
    AdminComponent,
  ],
  imports: [
    SharedModule,
    AdminDashRoutingModule,
    MatDialogModule,
    MatTabsModule
  ]
})
export class AdminDashModule { }
